import { render, staticRenderFns } from "./CreateItemRuleContent.vue?vue&type=template&id=1b3bd912&scoped=true&"
import script from "./CreateItemRuleContent.vue?vue&type=script&lang=js&"
export * from "./CreateItemRuleContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateItemRuleContent.vue?vue&type=style&index=0&id=1b3bd912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3bd912",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b3bd912')) {
      api.createRecord('1b3bd912', component.options)
    } else {
      api.reload('1b3bd912', component.options)
    }
    module.hot.accept("./CreateItemRuleContent.vue?vue&type=template&id=1b3bd912&scoped=true&", function () {
      api.rerender('1b3bd912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/ModalComponents/CreateItemRuleContent.vue"
export default component.exports